import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import moment from 'moment';
import classnames from 'classnames';

function OfflineMenu(props) {
    function renderConnectionMessage() {
        return !props.swEnabled ? (
            <span>
                <i className="cl-icon cl-icon-times-circle" /> Browser not
                offline compatible
            </span>
        ) : props.disconnectedAt ? (
            <span>
                <i className="cl-icon cl-icon-times-circle" /> No connectivity
            </span>
        ) : (
            <span>
                <i className="cl-icon cl-icon-check-circle text-success" />{' '}
                Connected to the Internet
            </span>
        );
    }

    function renderLastUpdatedMessage() {
        return props.disconnectedAt ? (
            <i>Last updated: {moment(props.disconnectedAt).fromNow()}</i>
        ) : (
            ''
        );
    }

    function renderConnectionButton() {
        const msg = props.disconnectedAt ? "I'm connected again" : 'Sync data';
        return <button className="btn btn-primary">{msg}</button>;
    }

    return (
        <div className="offline-menu-dropdown">
            <div className="dropdown-container">
                <div>{renderConnectionMessage()}</div>
                <MenuItem
                    aria-label="Reconnect"
                    className="offline-button-container"
                    value="reconnect"
                >
                    {renderConnectionButton()}
                    <span className="discrete">
                        {renderLastUpdatedMessage()}
                    </span>
                </MenuItem>
                <MenuItem aria-label="Learn more" value="learnMore">
                    <Link to="/applications">
                        Learn more about offline capabilities.
                    </Link>
                </MenuItem>
            </div>
        </div>
    );
}

OfflineMenu.propTypes = {
    disconnectedAt: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    swEnabled: PropTypes.bool,
};

function OfflineMenuIcon(props) {
    const offlineDataStillLoading = !props.isOfflineReady;

    const classes = classnames({
        'offline-not-ready': offlineDataStillLoading,
        'offline-menu-container': true,
        'is-online': !props.disconnectedAt,
        'is-offline': props.disconnectedAt,
        'offline-incompatible': !props.swEnabled,
    });

    function handleSelection(value) {
        const action = {
            reconnect: () => window.location.reload(),
            learnMore: () => props.routeToApplications(),
        }[value];
        action && action();
    }

    return (
        <Wrapper className={classes} onSelection={handleSelection}>
            <Button
                className="react-dropdown-button"
                disabled={offlineDataStillLoading}
            >
                <i
                    className="cl-icon cl-icon-bolt"
                    aria-label={props.disconnectedAt ? 'offline' : 'online'}
                />
            </Button>
            <Menu>
                <OfflineMenu {...props} />
            </Menu>
        </Wrapper>
    );
}

OfflineMenuIcon.propTypes = {
    disconnectedAt: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    swEnabled: PropTypes.bool,
    toolTipDirection: PropTypes.string,
    isOfflineReady: PropTypes.bool.isRequired,
    routeToApplications: PropTypes.func.isRequired,
};

export default OfflineMenuIcon;



// WEBPACK FOOTER //
// ./src/components/offline_menu.ui.jsx